export * from './voice-funnel.component';
